import { render, staticRenderFns } from "./MsgLeftItem.vue?vue&type=template&id=736defa6&scoped=true&"
import script from "./MsgLeftItem.vue?vue&type=script&lang=ts&"
export * from "./MsgLeftItem.vue?vue&type=script&lang=ts&"
import style0 from "./MsgLeftItem.vue?vue&type=style&index=0&id=736defa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736defa6",
  null
  
)

export default component.exports